import { toast } from 'react-toastify'

import { api } from 'api'
import { Success } from 'constants/actionMessages'
import { UpdateCfrDefaultParams } from 'interfaces/store/cfrDefaultParams.interfaces'
import { createAsyncThunk } from 'modules/store'

export const getAllCfrDefaultParams = createAsyncThunk(
  'cfrDefaultParams/getAllCfrDefaultParams',
  async (_, { rejectWithValue }) => api.cfrDefaultParams.getAll().catch((error) => rejectWithValue(error.message)),
)

export const updateCfrDefaultParams = createAsyncThunk(
  'cfrDefaultParams/updateCfrDefaultParams',
  async (params: UpdateCfrDefaultParams, { rejectWithValue, dispatch }) =>
    api.cfrDefaultParams
      .update(params.data)
      .then(() => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        dispatch(getAllCfrDefaultParams())
        toast.success(Success.Save)
      })
      .catch((error) => rejectWithValue(error.message)),
)
